import { getLogger } from '@/modules/observability/logging';
import { BuyerOfferDisplayStatus } from '@/modules/offers/buyers/types';

export function detectInvalidOfferStatuses(
  offers: Array<{ offer_display_status: string }>
) {
  const validStatuses = Object.values(BuyerOfferDisplayStatus) as string[];
  const uniqueStatuses = new Set(
    offers.map((offer) => offer.offer_display_status)
  );

  uniqueStatuses.forEach((status) => {
    if (!validStatuses.includes(status)) {
      getLogger().warn(`Unknown offer status received >> ${status}`);
    }
  });
}
